module.exports = __webpack_public_path__ + "d54bcbeece6e816354aafec885ddcfe3.woff";